// Suppress React error overlay in development and production
// This prevents Safari from showing the red error screen

// Disable React error overlay
const style = document.createElement('style');
style.textContent = `
  iframe#webpack-dev-server-client-overlay,
  iframe#webpack-dev-server-client-overlay-div {
    display: none !important;
  }
`;
document.head.appendChild(style);

// Capture and suppress errors that trigger overlays - minimal overhead
window.addEventListener(
  'error',
  (event) => {
    if (event.message && event.message.includes('Script error')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  },
  true
);

window.addEventListener(
  'unhandledrejection',
  (event) => {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  },
  true
);

export default {};
